import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import ButtonHOC from '../../hoc/buttonHOC';
import '../../../assets/scss/userDashboard.css';

const NameField = ({
  first_name,
  last_name,
  formValues,
  toggleNameInput,
  handleNameToggle,
  updateName,
  handleChange,
}) => {
  const { firstName, lastName } = formValues;

  if (toggleNameInput) {
    return (
      <React.Fragment>
        <div className="row align-items-center">
          <div className="col-md-4 row-title mb-md-0 mb-2">
            <FontAwesomeIcon icon="user" className="mt-1" />
            Name{' '}
          </div>
          <div className="col-md-8 p-0">
            <div className="d-flex flex-row flex-sm-nowrap flex-wrap justify-content-betwwen align-items-center px-3">
              <input
                placeholder="First Name"
                type="text"
                value={firstName}
                onChange={handleChange}
                name="firstName"
                className="col-md-5 col-sm-12 form-control mb-md-0 mb-2"
              />
              <input
                placeholder="Last Name"
                type="text"
                name="lastName"
                className="form-control"
                onChange={handleChange}
                value={lastName}
                className="col-md-5 col-sm-12 form-control mb-md-0 mb-2"
              />
              <button
                type="button"
                className="btn btn-success mb-md-0 mb-2 ml-md-1 ml-0 inline-ed-btn save"
                onClick={updateName}
              >
                <FontAwesomeIcon icon="check" className="m-0" />
              </button>
              <button
                type="button"
                className="btn btn-danger mb-md-0 mb-2 ml-md-1 ml-0 inline-ed-btn cancel"
                onClick={handleNameToggle}
              >
                <FontAwesomeIcon icon="times" className="m-0" />
              </button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-4 row-title mb-md-0 mb-2">
          <FontAwesomeIcon icon="user" className="mt-1" />
          Name{' '}
        </div>
        <div className="col-md-8">
          <div className="d-flex align-items-center justify-content-between">
            {first_name} {last_name}
            <ButtonHOC>
              <FontAwesomeIcon
                icon="pencil-alt"
                className="float-right mt-1 mr-3 cursor-pointer"
                onClick={handleNameToggle}
              />
            </ButtonHOC>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default NameField;



// WEBPACK FOOTER //
// ./src/components/users/details/NameField.js